<template>
  <v-list v-if="selectedLocation" disabled>
    <v-list-item-group>
      <template v-for="(hours, day) in hours">
        <v-list-item :key="day" v-if="hours && hours.open && hours.close">
          <v-list-item-avatar>
            <v-icon :color="(getCurrentDay() === day) ? 'primary' : 'gray'">fa-calendar</v-icon>
          </v-list-item-avatar>
          <v-list-item-content>
            <v-list-item-title>{{ day[0].toUpperCase() + day.substr(1, day.length) }}</v-list-item-title>
            <v-list-item-subtitle>
              {{ get12HourTime(parseTime(hours.open)) }} - {{ get12HourTime(parseTime(hours.close)) }}
            </v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>
      </template>
    </v-list-item-group>
  </v-list>
</template>

<script>
import { mapGetters } from 'vuex'

import { parseTime, get12HourTime, sortHours } from '@/utils/utils'

export default {
  name: 'Hours',
  data () {
    return {
      currentTime: new Date()
    }
  },
  computed: {
    ...mapGetters([
      'selectedLocation'
    ]),
    currentTimeString () {
      return `${this.currentTime.getHours()}:${(this.currentTime.getMinutes() < 10 ? '0' : '')}${this.currentTime.getMinutes()}`
    },
    hours () {
      return sortHours(this.selectedLocation.hours)
    }
  },
  methods: {
    parseTime: parseTime,
    get12HourTime: get12HourTime,
    getCurrentDay () {
      const currentDate = new Date()
      const days = ['sunday', 'monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday']

      return days[currentDate.getDay()]
    }
  }
}
</script>
